import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  
  // Register the service worker for both production and development
  if (publicUrl.origin === window.location.origin) {
    window.addEventListener('load', () => {
      serviceWorkerRegistration.register({
        onSuccess: (registration) => {
          console.log('ServiceWorker registration successful with scope: ', registration.scope);
          
          // Force trigger beforeinstallprompt for testing
          setTimeout(() => {
            if (!window.deferredPrompt) {
              console.log('Simulating beforeinstallprompt event for development');
              // Create a mock beforeinstallprompt event for development testing
              const mockEvent = {
                preventDefault: () => {},
                prompt: async () => {
                  return new Promise((resolve) => {
                    const userChoice = window.confirm(
                      'Install MoodSync App?\n\n' +
                      'This will add MoodSync to your home screen for quick access.'
                    );
                    resolve({
                      outcome: userChoice ? 'accepted' : 'dismissed',
                      platform: 'web'
                    });
                  });
                },
                userChoice: Promise.resolve({
                  outcome: 'accepted',
                  platform: 'web'
                })
              };
              
              // Only dispatch in development
              if (process.env.NODE_ENV === 'development') {
                window.dispatchEvent(new CustomEvent('beforeinstallprompt', { detail: mockEvent }));
              }
            }
          }, 1000);
        },
        onUpdate: (registration) => {
          console.log('New content is available; please refresh.');
          if (window.confirm('A new version of MoodSync is available! Would you like to update now?')) {
            window.location.reload();
          }
        },
        onError: (error) => {
          console.error('Error during service worker registration:', error);
        }
      });
    });
  }
}

// If you want to measure performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();